import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Column } from "primereact/column";
import EditAddForm from "./edit-add-form";
import Spinner from "../../components/spinner";
import { axiosApi } from "../../../services/axios_api";
import useDebounce from "../../components/hooks/useDebounce";
import { toast } from "react-toastify";
import { Tag } from "primereact/tag";
import moment from "moment";
import AssignUser from "./assign_user";

import ResolveStatus from "./resolve_status";
import PaginatorComponent from "../../components/paginator";
import { exportToExcel, renderTextWithTooltip } from "../../components/helper";
import editIcon from "../../../../assets/assests/edit.png";
import { Button } from "primereact/button";
import Dots from "../../../../assets/assests/detail.png";
import Details from "./details_customer";
export default function CustomerServicesManagements({
  showDialog,
  setShowDialog,
  isEdit,
  selectedData,
  globalFilter,
  exportCSV,
  statusFilter,
  fromDate,
  toDate,
}) {
  const [res, setRes] = useState([]);
  const [rowselect, setRowselect] = useState(null);
  const [editable, setEditable] = useState();
  const [loading, setLoading] = useState(false);
  const [filteredList, setFilteredList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [assignDialogVisible, setAssignDialogVisible] = useState(false);
  const [resolveDialogVisible, setResolveDialogVisible] = useState(false);
  const [selectedAssignRow, setSelectedAssignRow] = useState(null);

  const [showdetail, setShowdetail] = useState(false);
  const debouncedSearch = useDebounce(globalFilter, 500);

  const getCustomerServiceData = async (pageNumber = 1, pageSize = rows) => {
    setLoading(true);
    try {
      const response = await axiosApi.get(`/Portal/csr/get-all-paginated`, {
        params: {
          pageNumber,
          pageSize,
          searchTerm: debouncedSearch || "",
          status: statusFilter || undefined,
          fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : null,
          toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : null,
        },
      });
      setFilteredList(response.data.body);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      toast.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (event) => {
    const { first, rows } = event;
    setFirst(first);
    setRows(rows);
    const pageNumber = first / rows + 1;
    getCustomerServiceData(pageNumber, rows);
  };

  useEffect(() => {
    getCustomerServiceData();
  }, [debouncedSearch, statusFilter, fromDate, toDate]);

  const onHide = () => {
    setShowDialog(false);
    setAssignDialogVisible(false);
  };


  const actionTemplate = (rowData) => {
    return (
      <div className="action-buttons flex">

        <span
          style={{
            color: "#6BB1AE",
            textDecoration: "underline",
            cursor: "pointer",
            fontWeight: "600",
            fontSize: '14px',
            marginRight: '12px'
          }}
          onClick={() => handleDialogAssign(rowData)}
        >
          <i
            className="pi pi-user-edit  mr-2"
            style={{
              fontSize: '16px',
              fontWeight: "600",
            }}
          ></i>
          {rowData.Assign || "Assign User"}
        </span>

        <Button
          className=" p-button-edit p-0 mr-3"
          onClick={() => handleDialogResolve(rowData)}
          aria-label="Edit"
        >
          <img src={editIcon} alt="Edit" />
        </Button>
        <Button className="p-button-edit p-0 mr-3" onClick={() => showDetails(rowData)}>
          <img src={Dots} alt="Details" />
        </Button>


      </div>
    );
  };

  const columnsData = [
    {
      field: "id",
      header: "Request ID",
      body: (rowData) => rowData.id || "--",
      frozen: true,
    },
    {
      field: "customerName",
      header: "customer Name",
      body: (rowData) =>
        renderTextWithTooltip(rowData, "customerName", "bottom"),
      frozen: true,
    },
    {
      field: "customerMobileNumber",
      header: "customer Number",
      body: (rowData) => rowData.customerMobileNumber || "--",
    },
    {
      field: "assignedToName",
      header: "assigned Name",
      body: (rowData) =>
        renderTextWithTooltip(rowData, "assignedToName", "bottom"),
    },
    {
      field: "issueType",
      header: "Issue Type",
      body: (rowData) => renderTextWithTooltip(rowData, "issueType", "bottom"),
    },
    {
      field: "description",
      header: "description",
      body: (rowData) =>
        renderTextWithTooltip(rowData, "description", "bottom"),
    },
    {
      field: "statusChangeComments",
      header: "Remarks",
      body: (rowData) =>
        renderTextWithTooltip(rowData, "statusChangeComments", "bottom"),
    },
    // {
    //   field: "assignmentComments",
    //   header: "assignment Comments",
    //   body: (rowData) =>
    //     renderTextWithTooltip(rowData, "assignmentComments", "bottom"),    },

    // {
    //   field: "assignedTo",
    //   header: "assigned To",
    //   body: (rowData) => rowData.assignedTo || "--",
    // },

    // {
    //   field: "assignedDateTime",
    //   header: "assigned Date Time",
    //   body: (rowData) =>
    //     rowData.assignedDateTime
    //       ? moment(rowData.assignedDateTime).format("YYYY-MM-DD HH:mm:ss")
    //       : "--",
    // },
    {
      field: "modifiedDate",
      header: "Date",
      body: (rowData) =>
        rowData.modifiedDate
          ? moment(rowData.modifiedDate).format("YYYY-MM-DD HH:mm:ss")
          : "--",
    },
    // {
    //   field: "createdDate",
    //   header: "created Date",
    //   body: (rowData) =>
    //     rowData.createdDate
    //       ? moment(rowData.createdDate).format("YYYY-MM-DD HH:mm:ss")
    //       : "--",
    // },
    {
      field: "status",
      header: "Status",
      body: (rowData) => (
        <Tag
          className={
            rowData.status === "On Hold"
              ? "custom-warning-tag"
              : "custom-success-tag"
          }
          value={rowData.status ?? "--"}
        />
      ),
    },
    {
      header: "Action",
      body: actionTemplate,
    },


  ];
  const handleDialogAssign = (rowData) => {
    setSelectedAssignRow(rowData);
    setAssignDialogVisible(true);
  };

  const handleDialogResolve = (rowData) => {
    setSelectedAssignRow(rowData);
    setResolveDialogVisible(true);
  };

  // Separate onHide functions
  const hideAssignDialog = () => {
    setAssignDialogVisible(false);
  };

  const hideResolveDialog = () => {
    setResolveDialogVisible(false);
  };

  const exportCSVHandler = async () => {
    setLoading(true);
    try {
      const response = await axiosApi.get(`/Portal/csr/get-all`);
      exportToExcel(response.data.body, columnsData, "CustomerRequestData");
    } catch (error) {
      toast.error("Failed to export data.");
      console.error("Export Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (exportCSV) {
      exportCSV.current = exportCSVHandler;
    }
  }, []);
  const showDetails = (rowData) => {
    setRowselect(rowData);
    setShowdetail(true);
  }
  return (
    <>
      <Dialog
        header="Assign User"
        visible={assignDialogVisible}
        onHide={hideAssignDialog}
        className="dialog-size"
      >
        <AssignUser
          rowData={selectedAssignRow}
          setShowDialog={setAssignDialogVisible}
          onHide={hideAssignDialog}
          setRes={setRes}
        />
      </Dialog>

      {/* Resolve Dialog */}
      <Dialog
        header="Mark Resolve"
        visible={resolveDialogVisible}
        onHide={hideResolveDialog}
        className="dialog-size"
      >
        <ResolveStatus
          rowData={selectedAssignRow}
          setShowDialog={setResolveDialogVisible}
          onHide={hideResolveDialog}
          setRes={setRes}
        />
      </Dialog>

      <Dialog
        header={
          <div className="popup-header">
            <div className="popup-header-text">
              {isEdit ? "Edit User" : "Add New Request"}
            </div>
          </div>
        }
        visible={showDialog}
        onHide={onHide}
        className="dialog-size"
      >
        <EditAddForm
          rowData={rowselect}
          setShowDialog={setShowDialog}
          getCustomerServiceData={getCustomerServiceData}
          showDialog={showDialog}
          editable={editable}
          onHide={onHide}
          formData={isEdit ? selectedData : null}
          setRes={setRes}
        />
      </Dialog>
      <Dialog
        visible={showdetail}
        onHide={() => setShowdetail(false)}
        header="Customer Service Details"
       className="dialog-size"
      >
        <Details
                  rowData={ rowselect } />
      </Dialog>

      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}

      <div className="card card-container">
        <DataTable
          emptyMessage="No record found."
          value={filteredList}
          className="custom-data-table"
          scrollable
          globalFilter={globalFilter}
        >
          {columnsData.map((data, index) => (
            <Column
              key={index}
              field={data.field}
              header={data.header}
              body={data.body}
              frozen={data.frozen}
            />
          ))}
        </DataTable>
        {totalRecords > 0 && (
          <PaginatorComponent
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </>
  );
}
